const PAIN_POINTS = [
  {
    icon: 'ri-shopping-cart-line',
    title: 'High Traffic, Low Conversions?',
    body: 'You\'re getting visitors but they\'re not buying. Most ecommerce stores struggle to turn browsers into buyers — not because of their products, but because their ads aren\'t speaking to the right people with the right message.',
    stat: '69% of ecommerce stores',
    statLabel: 'say converting ad traffic is their #1 challenge',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Burning Through Ad Budget With No ROI?',
    body: 'You\'ve tried Facebook ads and Google Shopping, but your cost per acquisition keeps climbing. Weak copy and poor creative drain your budget fast — leaving you with traffic but no profit.',
    stat: '$6,800 avg.',
    statLabel: 'wasted per year on underperforming ecommerce ads',
  },
  {
    icon: 'ri-time-line',
    title: 'Spending Too Much Time on Creative?',
    body: 'Writing ad copy, sourcing images, resizing for every platform — it\'s a full-time job. You should be focused on products and fulfillment, not stuck in Canva at midnight.',
    stat: '8+ hours/week',
    statLabel: 'lost on ad creative and copywriting',
  },
];

export default function EcommercePainPoints() {
  return (
    <section className="py-20 lg:py-24 bg-stone-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-400 uppercase tracking-widest mb-3">
            Sound Familiar?
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4 leading-tight">
            The Real Problems Ecommerce Stores Face with Advertising
          </h2>
          <p className="text-base text-stone-400 max-w-xl mx-auto">
            You didn&apos;t build your store to become a full-time marketer. But without great ads, growth stalls.
            Here&apos;s what most ecommerce owners deal with every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PAIN_POINTS.map((point) => (
            <div
              key={point.title}
              className="bg-white/5 border border-white/10 rounded-2xl p-7 flex flex-col gap-4 hover:bg-white/8 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-500/20 text-orange-400">
                <i className={`${point.icon} text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-white leading-snug">{point.title}</h3>
              <p className="text-sm text-stone-400 leading-relaxed flex-1">{point.body}</p>
              <div className="pt-4 border-t border-white/10">
                <span className="text-xl font-black text-orange-400">{point.stat}</span>
                <p className="text-xs text-stone-500 mt-1">{point.statLabel}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base text-stone-300 font-medium">
            AdForge fixes all three — in under 3 minutes.
          </p>
        </div>
      </div>
    </section>
  );
}
